/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'

export const ConversationListContext = createContext(null)

export const ConversationListProvider = ({ children }) => {
  const conversationListRef = useRef(null)

  const setConversationListRef = useCallback((ref) => {
    conversationListRef.current = ref
  }, [])

  const addNewConversation = useCallback((conversationId) => {
    if (conversationListRef.current && conversationListRef.current.addNewConversation) {
      conversationListRef.current.addNewConversation(conversationId)
    }
  }, [])

  return (
    <ConversationListContext.Provider
      value={{
        setConversationListRef,
        addNewConversation,
      }}
    >
      {children}
    </ConversationListContext.Provider>
  )
}

ConversationListProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useConversationList = () => {
  const context = useContext(ConversationListContext)
  if (!context) {
    throw new Error('useConversationList must be used within ConversationListProvider')
  }
  return context
}
